import type { FunctionComponent } from "react";

import { WaveUpperBackground } from "~/components/posties/wave-background";

import { Balloons } from "./balloons";
import { BottomBackground } from "./bottom-background";
import { Container, ContentWrapper, StyledSubscriptionWidget } from "./styles";

type Props = {
  id: string;
};

export const SubscriptionPlan: FunctionComponent<Props> = ({ id }) => (
  <Container id={id}>
    <WaveUpperBackground $fillColor="#E3F7FF" />
    <ContentWrapper>
      <Balloons />
      <StyledSubscriptionWidget variant="brochure" />
      <BottomBackground />
    </ContentWrapper>
  </Container>
);

SubscriptionPlan.displayName = "SubscriptionPlan";
